import { Record } from 'immutable'

export interface IAssociatedDevelopmentClient {
  readonly clientId: string
  readonly name: string
}

const AssociatedDevelopmentClientRecord = Record({
  clientId: '',
  name: '',
})

export class AssociatedDevelopmentClient
  extends AssociatedDevelopmentClientRecord
  implements IAssociatedDevelopmentClient {
  public static fromJS(initialState?: Partial<IAssociatedDevelopmentClient>) {
    if (!initialState) {
      return new AssociatedDevelopmentClient()
    }

    const { ...rest } = initialState

    return new AssociatedDevelopmentClient({
      ...rest,
    })
  }

  public readonly clientId: string
  public readonly name: string

  constructor(initialState?: Partial<AssociatedDevelopmentClient>) {
    initialState ? super(initialState) : super()
  }
}
